import { EPageTypes, EPlatformTypes, SimpleCall } from '@cian/frontend-newbuilding-call-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackShowPhone } from '../../actions/analytics';
import { SinglePhoneComponent } from '../../components/SinglePhoneComponent';
import { getSellers } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';
import { getGaLabel } from '../../selectors/analytics';

interface ILeadFactoryCallButtonContainerProps {
  placeType: string;
  trackAction?: string;
  size: 'M' | 'XS';
  theme?: 'fill_primary' | 'fill_secondary';
}

export const LeadFactoryCallButtonContainer: React.FC<ILeadFactoryCallButtonContainerProps> = ({
  placeType,
  size,
  theme = 'fill_primary',
  trackAction = 'Open_jk_card_blockJK',
}) => {
  const sellers = useSelector(getSellers);
  const gaLabel = useSelector(getGaLabel);
  const { httpApi, logger } = useApplicationContext();

  const styles = { size, fullWidth: true, theme };

  const handleClick = React.useCallback(() => trackShowPhone(gaLabel, trackAction), [gaLabel]);

  return (
    <div data-testid={`LeadFactoryCallButtonBlock-${placeType}`}>
      <SimpleCall
        builders={[]}
        sellers={sellers}
        openContactsStyles={styles}
        showPhoneStyles={styles}
        httpApi={httpApi}
        logger={logger}
        onShowPhoneClick={handleClick}
        pageType={EPageTypes.NewbuildingCard}
        platformType={EPlatformTypes.WebDesktop}
        placeType={placeType}
        singlePhoneButtonText="Позвонить консультанту"
        multiplePhoneButtonText="Позвонить консультанту"
        SinglePhoneComponent={size === 'M' ? SinglePhoneComponent : undefined}
      />
    </div>
  );
};
